// Internal dev/test partner ids all share this literal prefix (see cognitoGroups
// filter in api/auth.js), so stripping it first gives initials that reflect the
// account itself rather than "PI" for every one of them.
const TEST_PARTNER_PREFIX = /^partner-id-/i

export function getAccountInitials(accountId) {
  const label = String(accountId || '').replace(TEST_PARTNER_PREFIX, '')
  const words = label.split(/[\s-_]+/).filter(Boolean)

  if (words.length >= 2) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase()
  }

  return label.slice(0, 2).toUpperCase()
}
